import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'res-custom-radio-button',
    templateUrl: './custom-radio-button.component.html',
    styleUrls: ['./custom-radio-button.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomRadioButtonComponent),
            multi: true
        }
    ]
})
export class CustomRadioButtonComponent implements ControlValueAccessor {
    @ViewChild('radioButtonInput', { static: true }) radioButtonInput: ElementRef;

    radioButtonId = '_' + window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36);
    @Input() name: string;
    @Input() formControlName: string;
    @Input() value: any;
    model: any;

    @Input() content: string;

    @Input() automationId = 'custom';
    @Input() isDisabled: boolean;

    // use marginLeft if the whole checkbox needs a margin left, as it has no margins or paddings by default
    @Input() marginLeft: number;
    // use marginRight if the whole checkbox needs a margin right, as it has no margins or paddings by default
    @Input() marginRight: number;

    // use labelPaddingLeft if the checkbox needs padding left. this will make the checkbox clickable on its whole padding
    @Input() labelPaddingLeft: number;
    // use labelPaddingRight if the checkbox needs padding right. this will make the checkbox clickable on its whole padding
    @Input() labelPaddingRight: number;

    // use notClickable when the input and label shouldn't be clickable, when some other evens already select the checkbox (need so it doesn't trigger selection twice)
    @Input() notClickable: boolean;

    // title 
    @Input() titleText: string;
    @Input() iconTooltip: string;

    private propagateChange = (_: any) => {
        return;
    };

    writeValue(value: any): void {
        this.model = value;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        return;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onClick(): void {
        if (!this.isDisabled && this.radioButtonInput) {
            this.radioButtonInput.nativeElement.click();
        }
    }

    onChange(): void {
        this.propagateChange(this.model);
    }
}
